import { render, staticRenderFns } from "./BrowseExtraButtonEdit.vue?vue&type=template&id=315751d8&scoped=true&"
import script from "./BrowseExtraButtonEdit.vue?vue&type=script&lang=ts&"
export * from "./BrowseExtraButtonEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseExtraButtonEdit.vue?vue&type=style&index=0&id=315751d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315751d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315751d8')) {
      api.createRecord('315751d8', component.options)
    } else {
      api.reload('315751d8', component.options)
    }
    module.hot.accept("./BrowseExtraButtonEdit.vue?vue&type=template&id=315751d8&scoped=true&", function () {
      api.rerender('315751d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BrowseExtraButtonEdit.vue"
export default component.exports